import React from 'react';
import Icon from '../../../components/AppIcon';

const EquipmentStatusGrid = () => {
  const equipmentData = [
    {
      id: 'HPLC-001',
      name: 'HPLC System #1',
      type: 'HPLC',
      status: 'operational',
      lastCalibration: '2024-09-15',
      nextCalibration: '2024-12-15',
      utilizationRate: 87,
      location: 'Lab A-101'
    },
    {
      id: 'HPLC-002',
      name: 'HPLC System #2',
      type: 'HPLC',
      status: 'maintenance',
      lastCalibration: '2024-08-20',
      nextCalibration: '2024-11-20',
      utilizationRate: 0,
      location: 'Lab A-102'
    },
    {
      id: 'GC-001',
      name: 'Gas Chromatograph #1',
      type: 'GC',
      status: 'operational',
      lastCalibration: '2024-09-10',
      nextCalibration: '2024-12-10',
      utilizationRate: 92,
      location: 'Lab B-201'
    },
    {
      id: 'UV-001',
      name: 'UV Spectrophotometer',
      type: 'UV-Vis',
      status: 'calibration_due',
      lastCalibration: '2024-06-18',
      nextCalibration: '2024-09-18',
      utilizationRate: 65,
      location: 'Lab A-103'
    },
    {
      id: 'FTIR-001',
      name: 'FTIR Spectrometer',
      type: 'FTIR',
      status: 'operational',
      lastCalibration: '2024-09-12',
      nextCalibration: '2024-12-12',
      utilizationRate: 78,
      location: 'Lab C-301'
    },
    {
      id: 'DSC-001',
      name: 'Differential Scanning Calorimeter',
      type: 'DSC',
      status: 'operational',
      lastCalibration: '2024-09-08',
      nextCalibration: '2024-12-08',
      utilizationRate: 54,
      location: 'Lab C-302'
    }
  ];

  const getStatusConfig = (status) => {
    switch (status) {
      case 'operational':
        return {
          color: 'text-success',
          bgColor: 'bg-success/10',
          icon: 'CheckCircle',
          label: 'Operational'
        };
      case 'maintenance':
        return {
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          icon: 'Wrench',
          label: 'Maintenance'
        };
      case 'calibration_due':
        return {
          color: 'text-error',
          bgColor: 'bg-error/10',
          icon: 'AlertTriangle',
          label: 'Calibration Due'
        };
      default:
        return {
          color: 'text-muted-foreground',
          bgColor: 'bg-muted',
          icon: 'Circle',
          label: 'Unknown'
        };
    }
  };

  const getUtilizationColor = (rate) => {
    if (rate >= 80) return 'text-success';
    if (rate >= 60) return 'text-warning';
    return 'text-error';
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Laboratory Equipment Status</h3>
          <p className="text-sm text-muted-foreground">Real-time equipment monitoring and calibration tracking</p>
        </div>
        <div className="flex items-center space-x-2">
          <button className="px-3 py-1 text-xs font-medium text-primary hover:bg-primary/5 border border-primary rounded-md transition-colors duration-150">
            View All
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {equipmentData?.map((equipment) => {
          const statusConfig = getStatusConfig(equipment?.status);
          return (
            <div key={equipment?.id} className="border border-border rounded-lg p-4 hover:shadow-sm transition-shadow duration-150">
              <div className="flex items-center justify-between mb-3">
                <div className={`p-2 rounded-lg ${statusConfig?.bgColor}`}>
                  <Icon name="Settings" size={16} className={statusConfig?.color} />
                </div>
                <div className={`flex items-center space-x-1 px-2 py-1 rounded-full ${statusConfig?.bgColor}`}>
                  <Icon name={statusConfig?.icon} size={12} className={statusConfig?.color} />
                  <span className={`text-xs font-medium ${statusConfig?.color}`}>
                    {statusConfig?.label}
                  </span>
                </div>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-foreground text-sm">{equipment?.name}</h4>
                <p className="text-xs text-muted-foreground">{equipment?.location}</p>
                
                <div className="flex items-center justify-between">
                  <span className="text-xs text-muted-foreground">Utilization</span>
                  <span className={`text-xs font-medium ${getUtilizationColor(equipment?.utilizationRate)}`}>
                    {equipment?.utilizationRate}%
                  </span>
                </div>

                <div className="space-y-1">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-muted-foreground">Last Cal:</span>
                    <span className="text-foreground font-mono">
                      {formatDate(equipment?.lastCalibration)}
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-muted-foreground">Next Cal:</span>
                    <span className="text-foreground font-mono">
                      {formatDate(equipment?.nextCalibration)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EquipmentStatusGrid;